import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation, useHistory } from "react-router-dom";
import authentificationService from "../../services/authentificationService";
import localStorageService from "../../services/localStorageService";
import {
  candidateLogout,
  AddProfileImage,
} from "../../redux/actions/admin/CandidateActions";
import ReactLoading from "react-loading";

let CandidateSideBar = (props) => {
  const { candidateLogout, AddProfileImage } = props;
  const history = useHistory();
  const location = useLocation();
  const [candidatToUpdate, setCandidatToUpdate] = React.useState();
  const [currrentPathName, setCurrrentPathName] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    getPathName();
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatToUpdate(candidate);
    } else {
      history.push(`/`);
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setCurrrentPathName(location.pathname);
  }, [location]);

  let getPathName = () => {
    let pathName = window.location.pathname;
    setCurrrentPathName(pathName);
  };

  const handleImageChange = (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (event.target.files.length > 0) {
      try {
        let candidate = localStorageService.getItem("malibaara_auth_candidate");
        AddProfileImage(candidate?.id, event.target.files).then((res) => {
          if (res.success) {
            setCandidatToUpdate(res.candidate);
            setIsLoading(false);
          }
        });
      } catch (error) {
        console.error("Error uploading profile image:", error);
      }
    }
  };

  let disconnect = (sessionType) => {
    authentificationService.logout(sessionType);
    if (sessionType == "candidate") {
      candidateLogout();
      window.location = "/";
    }
  };
  return (
    <>
      <React.Fragment>
        <div className="col-lg-4" style={{ marginBottom: "20px" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-light-3 p-4">
                <div className="p-4">
                  <div className="candidates-user-info">
                    <div className="jobster-user-info">
                      <div className="profile-avatar-container">
                        {isLoading ? (
                          <div>
                            <ReactLoading type="bubbles" color="#007cb5" />
                          </div>
                        ) : (
                          <>
                            <div className="profile-avatar">
                              {candidatToUpdate?.profilePictureUrl ? (
                                <>
                                  <img
                                    className="img-fluid"
                                    src={candidatToUpdate.profilePictureUrl}
                                    alt="Avatar"
                                  />
                                  <label
                                    htmlFor="avatarInput"
                                    className="custom-file-upload"
                                  >
                                    <i className="fas fa-pencil-alt"></i>
                                  </label>
                                </>
                              ) : (
                                <>
                                  <img
                                    className="img-fluid"
                                    src="assets/images/avatar/avatar2.png"
                                    alt="Avatar"
                                  />
                                  <label
                                    htmlFor="avatarInput"
                                    className="custom-file-upload"
                                  >
                                    <i className="fas fa-pencil-alt"></i>
                                  </label>
                                </>
                              )}
                              <input
                                type="file"
                                id="avatarInput"
                                name="avatarInput"
                                accept="image/png, image/jpeg"
                                style={{ display: "none" }}
                                onChange={handleImageChange}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      <div className="profile-avatar-info">
                        <h3>
                          {candidatToUpdate?.firstName || ""}{" "}
                          {candidatToUpdate?.lastName || ""}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="progress mt-2">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${candidatToUpdate?.completionPercentage}%`,
                      }}
                      aria-valuenow={candidatToUpdate?.completionPercentage}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div className="candidates-skills">
                    <div className="candidates-skills-info mb-4">
                      <h3 className="text-primary">
                        {candidatToUpdate?.completionPercentage}%
                      </h3>
                      <span className="d-block">
                        {candidatToUpdate?.completionText}
                      </span>
                    </div>
                  </div>
                  <div className="secondary-menu-candidate">
                    <ul className="list-unstyled mb-0">
                      <li>
                        <a
                          className={
                            currrentPathName.includes("/candidates/profile")
                              ? "active"
                              : ""
                          }
                          href="/candidates/profile"
                        >
                          Mon Compte
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            currrentPathName.includes("/candidates/documents")
                              ? "active"
                              : ""
                          }
                          href="/candidates/documents"
                        >
                          Mes Documents
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            currrentPathName.includes("/candidates/resume")
                              ? "active"
                              : ""
                          }
                          href="/candidates/resume"
                        >
                          Éditer Mon CV
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            currrentPathName.includes("/candidates/downloadResume")
                              ? "active"
                              : ""
                          }
                          href="/candidates/downloadResume"
                        >
                          Télécharger mon CV
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            currrentPathName.includes(
                              "/candidates/changePassword"
                            )
                              ? "active"
                              : ""
                          }
                          href="/candidates/changePassword"
                        >
                          Changement de Mot de Passe
                        </a>
                      </li>
                      <li>
                        <a
                          className=""
                          href="javascript:void(0)"
                          onClick={(e) =>
                            disconnect(
                              candidatToUpdate != null
                                ? "candidate"
                                : "employer "
                            )
                          }
                        >
                          Déconnexion
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </>
  );
};

CandidateSideBar.propTypes = {
  candidateLogout: PropTypes.func.isRequired,
  AddProfileImage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  candidateLogout: PropTypes.func.isRequired,
  AddProfileImage: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, { candidateLogout, AddProfileImage })(
  CandidateSideBar
);
